module.exports = __webpack_public_path__ + "static/el-obrero-internacional-4-3c31f9321dad1bf13886387f6abfd1b6.png";